import React from 'react'

const RightsholderContactInformationContentHeader = () => (
    <>
        <p>
            The only required contact type is the Public Contact, which will show in the Public Work Search. Only first
            name and email are required.
        </p>
        <p>
            For full information about public database contact types, click&nbsp;
            <a target="_blank" rel="noreferrer" href="https://help.themlc.com/en/support/contact-types">
                here.
            </a>
        </p>
    </>
)

export default RightsholderContactInformationContentHeader
